import {
    createAction,
} from '@shared/common';

const TYPE_NAMESPACE = 'DIALOG';

export const standard = {
    start: createAction(
        `${TYPE_NAMESPACE}/START`,
        (config) => (config),
    ),
    show: createAction(
        `${TYPE_NAMESPACE}/SHOW`,
        (config) => (config),
    ),
    accept: createAction(
        `${TYPE_NAMESPACE}/ACCEPT`,
        ({action}) => ({action}),
    ),
    cancel: createAction(
        `${TYPE_NAMESPACE}/CANCEL`,
        ({action}) => ({action}),
    ),
    close: createAction(
        `${TYPE_NAMESPACE}/CLOSE`,
    ),
    hidden: createAction(
        `${TYPE_NAMESPACE}/HIDDEN`,
    ),
};
